// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file unacast/boundaries/authpb/v1/auth.proto (package unacast.boundaries.authpb.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * @generated from enum unacast.boundaries.authpb.v1.PKCEProvider
 */
export enum PKCEProvider {
  /**
   * @generated from enum value: PKCE_PROVIDER_UNSPECIFIED = 0;
   */
  PKCE_PROVIDER_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PKCE_PROVIDER_GOOGLE = 1;
   */
  PKCE_PROVIDER_GOOGLE = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(PKCEProvider)
proto3.util.setEnumType(PKCEProvider, "unacast.boundaries.authpb.v1.PKCEProvider", [
  { no: 0, name: "PKCE_PROVIDER_UNSPECIFIED" },
  { no: 1, name: "PKCE_PROVIDER_GOOGLE" },
]);

/**
 * @generated from message unacast.boundaries.authpb.v1.IDPCredential
 */
export class IDPCredential extends Message<IDPCredential> {
  /**
   * @generated from field: string token_type = 1;
   */
  tokenType = "";

  /**
   * @generated from field: string access_token = 2;
   */
  accessToken = "";

  /**
   * @generated from field: string id_token = 3;
   */
  idToken = "";

  /**
   * @generated from field: string refresh_token = 4;
   */
  refreshToken = "";

  /**
   * @generated from field: int64 expires_in = 5;
   */
  expiresIn = protoInt64.zero;

  constructor(data?: PartialMessage<IDPCredential>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.authpb.v1.IDPCredential";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "id_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "refresh_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "expires_in", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IDPCredential {
    return new IDPCredential().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IDPCredential {
    return new IDPCredential().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IDPCredential {
    return new IDPCredential().fromJsonString(jsonString, options);
  }

  static equals(a: IDPCredential | PlainMessage<IDPCredential> | undefined, b: IDPCredential | PlainMessage<IDPCredential> | undefined): boolean {
    return proto3.util.equals(IDPCredential, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.authpb.v1.Credential
 */
export class Credential extends Message<Credential> {
  /**
   * @generated from field: string id_token = 1;
   */
  idToken = "";

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken = "";

  /**
   * @generated from field: int64 expires_at = 3;
   */
  expiresAt = protoInt64.zero;

  /**
   * @generated from field: string uid = 4;
   */
  uid = "";

  /**
   * @generated from field: string email = 5;
   */
  email = "";

  constructor(data?: PartialMessage<Credential>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.authpb.v1.Credential";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "refresh_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "expires_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "uid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Credential {
    return new Credential().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Credential {
    return new Credential().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Credential {
    return new Credential().fromJsonString(jsonString, options);
  }

  static equals(a: Credential | PlainMessage<Credential> | undefined, b: Credential | PlainMessage<Credential> | undefined): boolean {
    return proto3.util.equals(Credential, a, b);
  }
}

